import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-remove\">\n  <path d=\"M1024 219.428571h-219.428571V146.285714a146.285714 146.285714 0 0 0-146.285715-146.285714H365.714286a146.285714 146.285714 0 0 0-146.285715 146.285714v73.142857H0v146.285715h146.285714v658.285714h731.428572V365.714286h146.285714zM365.714286 146.285714h292.571428v73.142857H365.714286zM292.571429 877.714286V365.714286h146.285714v512z m438.857142 0H585.142857V365.714286h146.285714z\" p-id=\"13380\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/remove.svg
// module id = VFDz
// module chunks = 12